function InitPlayVideo() 
{
    document.querySelectorAll('.video-container').forEach(function(videoContainer) {
        const video = videoContainer.querySelector('.video');
        const videoUi = videoContainer.querySelector('.video-ui');
        videoContainer.addEventListener('click', function(event) {
            if (video.paused) {
                videoUi.style.display = 'none';
                video.play();
            } else {
                videoUi.style.display = 'block';
                video.pause();
            }
        })
    })
}